module.exports = __webpack_public_path__ + "static/media/relatorios-icon.eb09d493.svg";